import React from "react";
import "./css/Teams.css";

function Teams() {
  const teams = [
    {
      url: "img/teams/David Tino edit.jpg",
      titel: "1. Mannschaft",
      altersklasse: "Elite",
      liga: "Oberliga",
      torwart: "Tino Erlich",
      feldspieler: "David Friedrich",
    },
    {
      url: "img/teams/Matthias Felix edit.jpg",
      titel: "2. Mannschaft",
      altersklasse: "Elite",
      liga: "Oberliga",
      torwart: "Felix Stege",
      feldspieler: "Matthias Dunkel",
    },
    {
      url: "img/teams/Robin Jakob edit.jpg",
      titel: "3. Mannschaft",
      altersklasse: "Elite",
      liga: "Oberliga",
      torwart: "Jakob Igel",
      feldspieler: "Robin Meinhard",
    },
    {
      url: "img/teams/Dummy.png",
      titel: "4. Mannschaft",
      altersklasse: "Elite",
      liga: "Verbandsliga",
      torwart: "Tom Meinhard",
      feldspieler: "Tarek Krüger",
    },
    {
      url: "img/teams/Marco Adrian.jpg",
      titel: "5. Mannschaft",
      altersklasse: "Elite",
      liga: "Verbandsliga",
      torwart: "Adrian Cranz",
      feldspieler: "Marco Schröder",
    },
    {
      url: "img/teams/Dummy.png",
      titel: "6. Mannschaft",
      altersklasse: "Elite",
      liga: "Landesliga",
      torwart: "Jeremy Bunzler",
      feldspieler: "Mark Shadow",
    },
    {
      url: "img/teams/Dummy.png",
      titel: "7. Mannschaft",
      altersklasse: "Elite",
      liga: "Landesliga",
      torwart: "Maurice Braun",
      feldspieler: "Domenique Meine",
    },
    {
      url: "img/teams/U15_Julius_Laurens_Mar2023.jpg",
      titel: "1. Mannschaft",
      altersklasse: "U19",
      liga: "",
      torwart: "Laurens Parlow",
      feldspieler: "Julius Eckard",
    },
    {
      url: "img/teams/U13_Ole_Carl.jpg",
      titel: "1. Mannschaft",
      altersklasse: "U17",
      torwart: "Ole Mertens",
      feldspieler: "Carl Dittmeyer",
    },
    {
      url: "img/teams/U13_Ben_Mikolaj.jpg",
      titel: "1. Mannschaft",
      altersklasse: "U15",
      liga: "Oberliga",
      torwart: "Ben Zimmermann",
      feldspieler: "Mikolaj Gorski",
    },
    {
      url: "img/teams/Dummy.png",
      titel: "2. Mannschaft",
      altersklasse: "U15",
      liga: "Verbandsliga",
      torwart: "Ansgar Hillebrandt",
      feldspieler: "Noah Müller",
    },
  ];

  return (
    <div className="page-background">
      <div className="page-content">
        <div className="teams-container">
          {teams.map((team, index) => (
            <div className="team-box" key={index}>
              <img
                src={team.url}
                alt={`${team.titel}`}
                className="team-image"
                onError={(e) => {
                  e.target.onerror = null; // Verhindert Endlosschleifen
                  e.target.src = 'img/teams/Dummy.png'; // Fallback-Bild
                }}
              />
              <div className="team-info">
                <h3 className="team-title">{team.altersklasse} {team.liga}: {team.titel}</h3>
                <p className="team-details">Torwart: {team.torwart}</p>
                <p className="team-details">Feldspieler: {team.feldspieler}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Teams;
